module.exports = __webpack_public_path__ + "static/Flatart_mobil_slider_tasarimi_1-99b22f45eab0bc553c386fe22ff41bd9.mp4";